import { Pipe, PipeTransform } from '@angular/core';
import { millisecondsToSeconds } from 'date-fns';

@Pipe({
  name: 'msToReadableDuration',
  pure: true,
})
export class MsToReadableDurationPipe implements PipeTransform {
  /**
   * Takes in a number in milliseconds, outputs a simple display number
   * and unit (Seconds/Minutes/Hours/Days).
   */
  transform(durationMs: number): { value: number; unit: string } {
    if (!durationMs) {
      return { unit: 'days', value: 0 };
    }

    const durationInSeconds = millisecondsToSeconds(durationMs);
    const SECOND = 1;
    const MINUTE = SECOND * 60;
    const HOUR = MINUTE * 60;
    const DAY = HOUR * 24;

    const timeUnits = [
      { value: SECOND, translation: 'second' },
      { value: MINUTE, translation: 'minute' },
      { value: HOUR, translation: 'hour' },
      { value: DAY, translation: 'day' },
    ];

    for (let i = 0; i < timeUnits.length; i++) {
      const unit = timeUnits[i];
      const hasPrevious = i > 0;
      const hasNext = i < timeUnits.length - 1;

      if (durationInSeconds == unit.value) {
        return {
          unit: unit.translation,
          value: durationInSeconds / unit.value,
        };
      } else if (hasPrevious && durationInSeconds < unit.value) {
        return {
          unit: timeUnits[i - 1].translation + 's',
          value: Math.ceil(durationInSeconds / timeUnits[i - 1].value),
        };
      } else if (!hasNext && durationInSeconds > unit.value) {
        return {
          unit: unit.translation + 's',
          value: Math.ceil(durationInSeconds / unit.value),
        };
      }
    }
  }
}
